var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnChevronSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.735 11.1653C17.334 11.5606 17.334 12.4394 16.735 12.8347L9.05074 17.905C8.38589 18.3437 7.5 17.8668 7.5 17.0703V6.9297C7.5 6.13315 8.38589 5.65633 9.05074 6.09502L16.735 11.1653Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChevronSolid);
export default __webpack_public_path__ + "static/media/icn_chevron_solid.b675e81467f5a532a601b02190b021da.svg";
export { ForwardRef as ReactComponent };